import Vue from "vue";
import Router from "vue-router";
import store from './store/index'

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./components/Home.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./components/Login.vue")
    },
    {
      path: "/RegistroB2Badmin",
      name: "admin",
      component: () => import("./components/RegistroB2Badmin.vue")
    },
    {
      path: '*',
      redirect: '/login'
    }
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
    } else {
      next('/login');
    }
  } else {
    next();
  }
});

export default router;
